import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const NotFoundPage = () => (
  <Layout>
    <SEO title="Contact Us" />
    <h1>Contact Us</h1>
    <form name="contact" method="POST" data-netlify="true">
      <label>
        Your Name:
        <div>
          <input type="text" name="name" />
        </div>
      </label>
      <label>Your Email:
        <div>
          <input type="email" name="email" />
        </div>
      </label>
        <label>Message:
        <div>
          <textarea name="message"></textarea>
        </div>
      </label>
      <div>
        <button type="submit">Send</button>
      </div>
    </form>
  </Layout>
)

export default NotFoundPage
